module.exports = __webpack_public_path__ + "static/media/20-dessverre.d304d67a.mp3";